import { render } from "./DialogRewardsRecords.vue?vue&type=template&id=9280da44&scoped=true&ts=true"
import script from "./DialogRewardsRecords.vue?vue&type=script&lang=ts"
export * from "./DialogRewardsRecords.vue?vue&type=script&lang=ts"

import "./DialogRewardsRecords.vue?vue&type=style&index=0&id=9280da44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9280da44"]])

export default __exports__